import { render, staticRenderFns } from "./ComboPago.vue?vue&type=template&id=371b40ae"
import script from "./ComboPago.vue?vue&type=script&lang=ts"
export * from "./ComboPago.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports